import cn from 'classnames';
import AdHocFieldGenerator from '../../../../../paymentJourneyRedesign/pages/ConfirmPurchase/components/DelegateForm/components/AdHocForm/components/AdHocFieldGenerator';
import s from './QuestionForm.module.scss';

export default function QuestionForm(props) {
  const { title, text, questions = [] } = props;

  if (questions.length === 0) return null;

  return (
    <div className={s.wrapper}>
      {title && <h2 className={s.title}>{title}</h2>}
      {text && (
        <div dangerouslySetInnerHTML={{ __html: text }} className={s.text} />
      )}
      <div className="row">
        {questions.map((question) => (
          <div
            key={question.name}
            className={cn(s.row, `col-xs-12 col-sm-${question.limit || 12}`)}
          >
            <AdHocFieldGenerator
              delegateUuid=""
              formInput={question}
              allFormInputs={questions}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
